import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import { Box, IconButton, Tooltip } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const {
  button: { CngButton },
  table: { CngCrudTable }
} = components

function VesselInfoTable(props) {
  const { data, onAddVesselInfo, onEditVesselInfo, onDeleteVesselInfo, showNotification } = props
  const { translate } = useTranslation(Namespace.UAE_MPCI)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let title = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.TITLE)
    let voyageNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.VOYAGE_NUMBER)
    let carrierIdentifier = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.CARRIER_IDENTIFIER)
    let vesselName = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.VESSEL_NAME)
    let imoNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.IMO_NUMBER)
    let vesselFirstUaePort = translate(Namespace.UAE_MPCI, UaeMpciKeys.VesselInfo.VESSEL_FIRST_UAE_PORT)

    return { title, voyageNumber, carrierIdentifier, vesselName, imoNumber, vesselFirstUaePort }
  }

  const columns = [
    { field: 'voyageNumber', title: translatedTextsObject.voyageNumber },
    { field: 'carrierIdentifier', title: translatedTextsObject.carrierIdentifier },
    { field: 'imoNumber', title: translatedTextsObject.imoNumber },
    { field: 'vesselName', title: translatedTextsObject.vesselName },
    { field: 'vesselFirstUaePort', title: translatedTextsObject.vesselFirstUaePort },
  ]

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" mb={1}>
        <CngButton
          color='primary'
          onClick={onAddVesselInfo}
          size='small'
          startIcon={<FontAwesomeIcon icon={['fal', 'plus']} />}
        >
          Add Vessel Info
        </CngButton>
      </Box>
      {data && data.length > 0 && (
        <Box>
          {data.map((item, index) => (
            <Box key={index} display="flex" alignItems="center" justifyContent="space-between" p={1} borderBottom="1px solid #eee">
              <Box>
                {item.vesselName && <span><strong>{translatedTextsObject.vesselName}:</strong> {item.vesselName} | </span>}
                {item.voyageNumber && <span><strong>{translatedTextsObject.voyageNumber}:</strong> {item.voyageNumber} | </span>}
                {item.imoNumber && <span><strong>{translatedTextsObject.imoNumber}:</strong> {item.imoNumber} | </span>}
                {item.carrierIdentifier && <span><strong>{translatedTextsObject.carrierIdentifier}:</strong> {item.carrierIdentifier}</span>}
              </Box>
              <Box>
                <Tooltip title="Edit">
                  <IconButton size="small" onClick={() => onEditVesselInfo(item)}>
                    <FontAwesomeIcon icon={['fal', 'pen']} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                  <IconButton size="small" onClick={() => onDeleteVesselInfo(item)}>
                    <FontAwesomeIcon icon={['fal', 'trash']} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}

export default VesselInfoTable
